import {MeasureEditor} from "../form/editors/MeasureEditor";
import {useObjectFromUrlResourceOrNull} from "../platform/hooks/PlatformHooks";
import {OptionalEditor} from "../form/editors/OptionalEditor";
import React, {useEffect} from "react";


export function ShaftLengthBonusElements(props: { editor: MeasureEditor, shaftDiameterEditor: OptionalEditor<string>, onCommonShaftsDiscovered: (lengths: number[]) => void }) {

    const suggestedLengts: number[] = ((props.shaftDiameterEditor.value === null) ? ([14]) : [parseFloat(props.shaftDiameterEditor.value), parseFloat(props.shaftDiameterEditor.value) * 2]);

    const commonShafts = useObjectFromUrlResourceOrNull(props.shaftDiameterEditor.value === null ? null : "/api/mechanical/common-shaft-lengths?shaftDiameter=" + props.shaftDiameterEditor.value) as (number[] | null);

    // Auto selection of first (smallest) common shaft length discovered for specific diameter... but only if smaller selected.
    useEffect(() => {
        if (commonShafts === null || commonShafts.length === 0) {
            return;
        }
        props.onCommonShaftsDiscovered(commonShafts)
    }, [JSON.stringify(commonShafts)]);

    if (commonShafts === null) {
        return <></>;
    }
    return <div className={"d-flex gap-1"}>
        {commonShafts.map(sugLen => <button className={"fs-7 border-0"} style={{borderBottomLeftRadius: "9px", borderBottomRightRadius: "9px"}} onClick={() => props.editor.populate(sugLen)}>{sugLen} mm</button>)}
    </div>

}